var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("validation-observer", { ref: "goalSummary" }, [
    _c(
      "div",
      { staticClass: "achievement-container" },
      [
        _c("section-title", {
          attrs: { "has-line": "", title: "Resúmenes de Logros Sometidos" }
        }),
        _vm.editing
          ? _c(
              "div",
              { staticClass: "row mx-0 rounded bg-secondary-13 p-3" },
              [
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 pl-md-0 mb-3 mb-md-0" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-drop-down", {
                                  staticClass: "dropdown",
                                  attrs: {
                                    "custom-error-msg":
                                      "Favor seleccione el periodo académico.",
                                    error: errors[0],
                                    fieldkey: "periodId",
                                    fieldname: "name",
                                    label: "Periodo Académico:",
                                    options: _vm.periods,
                                    placeholder: "Seleccione"
                                  },
                                  model: {
                                    value: _vm.model.period,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "period", $$v)
                                    },
                                    expression: "model.period"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1771778171
                      )
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6 pl-md-0 mb-3 mb-md-0" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-drop-down", {
                                  staticClass: "dropdown",
                                  attrs: {
                                    "custom-error-msg":
                                      "Favor seleccione el especialista que discutió logros.",
                                    error: errors[0],
                                    fieldkey: "specialistId",
                                    fieldname: "name",
                                    label: "Especialista que discutió Logros:",
                                    options: _vm.specialists,
                                    placeholder: "Seleccione"
                                  },
                                  model: {
                                    value: _vm.model.specialist,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "specialist", $$v)
                                    },
                                    expression: "model.specialist"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        253245265
                      )
                    })
                  ],
                  1
                ),
                _vm.model.period
                  ? [
                      _c(
                        "div",
                        { staticClass: "col-12 col-md-6 pr-md-0" },
                        [
                          _vm.showNumberInput(_vm.model.period)
                            ? _c("validation-provider", {
                                attrs: {
                                  rules:
                                    "required|differentFromZero|greaterThanZero"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors }) {
                                        return [
                                          _c("custom-input", {
                                            attrs: {
                                              "custom-error-msg":
                                                "Favor indique el número de sesiones ofrecidas.",
                                              error: errors[0],
                                              label:
                                                "Número de sesiones ofrecidas:",
                                              type: "number"
                                            },
                                            model: {
                                              value: _vm.model.sessions,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "sessions",
                                                  $$v
                                                )
                                              },
                                              expression: "model.sessions"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3957073108
                                )
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-12 my-3 px-md-0" },
                        [
                          _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ errors }) {
                                    return [
                                      _c("custom-text-area", {
                                        staticClass:
                                          "achievement-container__text-area",
                                        attrs: {
                                          id: "comment",
                                          "count-classes": [
                                            "d-block",
                                            "small-counter"
                                          ],
                                          "custom-error-msg":
                                            "Favor describa brevemente los logros del estudiante.",
                                          error: errors[0],
                                          label: _vm.inputLabel(
                                            _vm.model.period
                                          ),
                                          maxlength: 3000,
                                          name: "comment",
                                          "show-char-count": ""
                                        },
                                        model: {
                                          value: _vm.model.achievement,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.model,
                                              "achievement",
                                              $$v
                                            )
                                          },
                                          expression: "model.achievement"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2699734811
                            )
                          })
                        ],
                        1
                      )
                    ]
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-md-8 offset-md-4 text-right align-self-end px-md-0"
                  },
                  [
                    _c("action-button", {
                      attrs: {
                        i: "fas fa-times-circle",
                        text: "Cancelar",
                        variant: "outline-danger mr-3 mb-2 my-md-0"
                      },
                      on: { click: _vm.cancel }
                    }),
                    _c("action-button", {
                      attrs: {
                        i: "fas fa-flag-alt",
                        text: "Someter",
                        variant: "success"
                      },
                      on: { click: _vm.saveAchievement }
                    })
                  ],
                  1
                )
              ],
              2
            )
          : [
              _vm.periods.length
                ? _c(
                    "div",
                    {
                      staticClass:
                        "row mx-0 justify-content-center bg-secondary-13 py-3 px-2 mb-3"
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn col-12 col-md-6 bg-light-white py-0 font-weight-normal",
                          on: { click: _vm.switchEdit }
                        },
                        [
                          _c("em", {
                            staticClass: "fas fa-file-plus pr-3 text-green"
                          }),
                          _c("span", { staticClass: "button-text" }, [
                            _vm._v(
                              " Presione aquí para añadir resumen de logro "
                            )
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._l(_vm.achievements, function(achieve, idx) {
                return _c(
                  "div",
                  {
                    key: `achieve-${idx}`,
                    staticClass:
                      "rounded bg-secondary-13 row mx-0 justify-content-between align-items-center mb-3 p-3"
                  },
                  [
                    _c("div", { staticClass: "col-12 row" }, [
                      _c("div", { staticClass: "col-12 row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-4" },
                          [
                            _c("custom-input-display", {
                              attrs: {
                                label: "Periodo Académico:",
                                "label-class": "input-label"
                              },
                              model: {
                                value: achieve.period.name,
                                callback: function($$v) {
                                  _vm.$set(achieve.period, "name", $$v)
                                },
                                expression: "achieve.period.name"
                              }
                            })
                          ],
                          1
                        ),
                        _vm.showNumberInput(achieve.period)
                          ? _c("div", { staticClass: "col-12 col-md-4" }, [
                              _c(
                                "span",
                                { staticClass: "label d-block mt-1" },
                                [_vm._v(" Número de sesiones ofrecidas: ")]
                              ),
                              _vm._v(" " + _vm._s(achieve.sessions) + " ")
                            ])
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "col-12",
                            class: {
                              "col-md-4": _vm.showNumberInput(achieve.period),
                              "col-md-8": !_vm.showNumberInput(achieve.period)
                            }
                          },
                          [
                            _c("custom-input-display", {
                              attrs: {
                                label: "Especialista que discutió logros:",
                                "label-class": "input-label"
                              },
                              model: {
                                value: achieve.specialist.name,
                                callback: function($$v) {
                                  _vm.$set(achieve.specialist, "name", $$v)
                                },
                                expression: "achieve.specialist.name"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _c(
                        "div",
                        { staticClass: "col-12 row mt-3 align-items-start" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "col-12",
                              class: {
                                "col-md-11": _vm.canShowDeleteArchivement,
                                "col-md-12": !_vm.canShowDeleteArchivement
                              }
                            },
                            [
                              _c("div", { staticClass: "text-format" }, [
                                _vm._v(_vm._s(achieve.achievement))
                              ])
                            ]
                          ),
                          _vm.canShowDeleteArchivement
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "col-12 col-md-1 d-flex justify-content-md-end mt-2 mt-md-0"
                                },
                                [
                                  _c("action-button", {
                                    attrs: {
                                      i: "fas fa-times-circle",
                                      text: "Eliminar",
                                      variant: "danger"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteArchivement(achieve)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ])
                  ]
                )
              }),
              _vm.periods.length
                ? _c(
                    "div",
                    { staticClass: "d-flex justify-content-end" },
                    [
                      _vm.canShowButton
                        ? _c("action-button", {
                            attrs: {
                              i: "fas fa-file-plus",
                              text: "Añadir",
                              variant: "success"
                            },
                            on: { click: _vm.switchEdit }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }